import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = { class: "value text-xs" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = { class: "info-box" }
const _hoisted_10 = { class: "info-box" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-box col-span-2" }
const _hoisted_13 = { class: "value mt-1" }
const _hoisted_14 = {
  key: 0,
  class: "info-box col-span-2"
}
const _hoisted_15 = { class: "value mt-1" }
const _hoisted_16 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_18 = { class: "info-box" }
const _hoisted_19 = { class: "value font-bold" }
const _hoisted_20 = {
  key: 0,
  class: "info-box"
}
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 1,
  class: "info-box"
}
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_25 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_26 = {
  key: 0,
  class: "user-card"
}
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "text-xs text-gray-500" }
const _hoisted_29 = {
  key: 1,
  class: "user-card"
}
const _hoisted_30 = { class: "text-sm" }
const _hoisted_31 = { class: "text-xs text-gray-500" }
const _hoisted_32 = {
  key: 2,
  class: "user-card"
}
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = { class: "text-xs text-gray-500" }
const _hoisted_35 = { class: "mb-6" }
const _hoisted_36 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_37 = {
  key: 0,
  class: "info-box"
}
const _hoisted_38 = { class: "value text-xs" }
const _hoisted_39 = {
  key: 1,
  class: "info-box"
}
const _hoisted_40 = { class: "value" }
const _hoisted_41 = {
  key: 2,
  class: "info-box"
}
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 3,
  class: "info-box"
}
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "info-box" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "info-box" }
const _hoisted_48 = {
  key: 0,
  class: "info-box mt-4"
}
const _hoisted_49 = { class: "value mt-1 text-xs bg-gray-100 p-2 rounded" }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "metadata-pre" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpen) = $event)),
    "max-width": "900px",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      (_ctx.log)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "rounded-lg overflow-hidden"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_icon, { color: "white" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-file-document-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-xl font-bold text-white" }, "جزئیات لاگ", -1))
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: _ctx.close,
                  class: "hover:bg-white hover:bg-opacity-20"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "white" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_v_card_text, { class: "pa-6 max-h-[70vh] overflow-y-auto" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-base font-bold text-gray-700 mb-3 pb-2 border-b-2 border-blue-500" }, " اطلاعات پایه ", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "شناسه:", -1)),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.log.id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "نوع:", -1)),
                        _createVNode(_component_v_chip, {
                          color: _ctx.getTypeColor(_ctx.log.type),
                          small: "",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getTypeLabel(_ctx.log.type)), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "وضعیت:", -1)),
                        _createVNode(_component_v_chip, {
                          color: _ctx.getStatusColor(_ctx.log.status),
                          small: "",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getStatusLabel(_ctx.log.status)), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "اکشن:", -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.log.action), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "توضیحات:", -1)),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.log.description), 1)
                      ]),
                      (_ctx.log.reason)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "دلیل:", -1)),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.log.reason), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.log.errorMessage)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          type: "error",
                          dense: "",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("strong", null, "پیام خطا:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.log.errorMessage), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.log.amount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-base font-bold text-gray-700 mb-3 pb-2 border-b-2 border-green-500" }, " اطلاعات مالی ", -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "مبلغ:", -1)),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatAmount(_ctx.log.amount)) + " " + _toDisplayString(_ctx.log.currency || 'IRR'), 1)
                          ]),
                          (_ctx.log.previousBalance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "موجودی قبل:", -1)),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatAmount(_ctx.log.previousBalance)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.log.newBalance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "موجودی جدید:", -1)),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatAmount(_ctx.log.newBalance)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.log.user || _ctx.log.admin || _ctx.log.targetUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-base font-bold text-gray-700 mb-3 pb-2 border-b-2 border-purple-500" }, " اطلاعات کاربران ", -1)),
                        _createElementVNode("div", _hoisted_25, [
                          (_ctx.log.user)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "font-bold text-sm mb-2 text-blue-600" }, "کاربر", -1)),
                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.log.user.name), 1),
                                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.log.user.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.log.admin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "font-bold text-sm mb-2 text-purple-600" }, "ادمین", -1)),
                                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.log.admin.name), 1),
                                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.log.admin.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.log.targetUser)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "font-bold text-sm mb-2 text-indigo-600" }, "کاربر هدف", -1)),
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.log.targetUser.name), 1),
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.log.targetUser.email), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "text-base font-bold text-gray-700 mb-3 pb-2 border-b-2 border-orange-500" }, " اطلاعات فنی ", -1)),
                    _createElementVNode("div", _hoisted_36, [
                      (_ctx.log.ipAddress)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "آدرس IP:", -1)),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.log.ipAddress), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.log.device)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "دستگاه:", -1)),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.log.device), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.log.referenceId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "شناسه مرجع:", -1)),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.log.referenceId), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.log.relatedTable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "جدول مرتبط:", -1)),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.log.relatedTable), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "تاریخ ایجاد:", -1)),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.formatDate(_ctx.log.createdAt)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "خوانده شده:", -1)),
                        _createVNode(_component_v_chip, {
                          color: _ctx.log.isRead ? 'success' : 'warning',
                          "x-small": "",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.log.isRead ? 'بله' : 'خیر'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ])
                    ]),
                    (_ctx.log.userAgent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "User Agent:", -1)),
                          _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.log.userAgent), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.log.metadata && Object.keys(_ctx.log.metadata).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-base font-bold text-gray-700 mb-3 pb-2 border-b-2 border-gray-500" }, " متادیتا ", -1)),
                        _createElementVNode("pre", _hoisted_51, _toDisplayString(JSON.stringify(_ctx.log.metadata, null, 2)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "px-6 py-4 bg-gray-50 border-t" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _ctx.close,
                    elevation: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        class: "ml-1"
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("mdi-check", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[30] || (_cache[30] = _createTextVNode(" بستن ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}